import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";

const SuccessAlert = props => {

  const [alert, setAlert] = useState(true);

  useEffect(() => {
    // when the component is mounted, the alert is displayed for 20 seconds, unless persistant prop is present
    const timeId = setTimeout(() => {       
      if (! props.persistant)
        setAlert(false);

    }, 5 * 1000);
    
    return () => {
      clearTimeout(timeId)
    }
  }, [props.message, props.persistant,props.lastStateUpdate]);  

  useEffect(() => {
    setAlert(true)
  }, [props.message, props.lastStateUpdate])

  return props.message && alert ? (
    <div className="alert alert-success" role="alert">{props.message}</div>
  ) : null
  
};

SuccessAlert.propTypes = {
  message: PropTypes.string,
  persistant: PropTypes.bool,
  lastStateUpdate: PropTypes.object
};
export default SuccessAlert;